<avi-data-grid
    [config]="licenseListGridConfig"
    [rows]="licenses"
    gridTitle="{{ l10nKeys.licensesHeader | vtranslate }}"
    [isLoading]="isBusy"
    [hasAlerts]="showLegacyLicenseAlert$ | async"
>
    <avi-data-grid_alerts>
        <avi-alert-group
            *ngIf="showLegacyLicenseAlert$ | async"
            alertType="danger"
            size="sm"
        >
            <span class="license-list__alert-group-content">
                {{ legacyLicenseAlertMessage }}
                <a
                    [href]="aviLoadBalancerLicensingKbUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="license-list__alert-button btn-sm btn-link"
                >
                    {{ l10nKeys.learnMoreLabel | vtranslate }}
                </a>
            </span>
        </avi-alert-group>
    </avi-data-grid_alerts>
    <avi-data-grid_actions class="license-list__action-section">
        <cds-button
            (click)="openAddLicenseModal()"
            (keydown.enter)="openAddLicenseModal()"
            [disabled]="isBusy"
            *ngIf="showAddLicenseButton"
            action="outline"
            class="sel-add-license-button"
            id="license-list-add-button"
            size="sm"
        >
            {{ l10nKeys.addLicenseKeyLabel | vtranslate }}
        </cds-button>
        <cds-button
            (click)="onRefreshLicenses()"
            (keydown.enter)="onRefreshLicenses()"
            [disabled]="isBusy"
            *ngIf="showRefreshButton"
            action="outline"
            class="sel-refresh-license-button"
            id="license-list-refresh-button"
            size="sm"
        >
            {{ l10nKeys.refreshLicensesButtonLabel | vtranslate }}
        </cds-button>
    </avi-data-grid_actions>
</avi-data-grid>
